<template>
  <hr-layout view="lHh Lpr lFf">
    <hr-page-container class="main-surface">
      <router-view />
    </hr-page-container>
  </hr-layout>
</template>

<script>
import { get } from 'lodash';
import { useMeta } from 'quasar';
import { HrLayout, HrPageContainer } from 'src/design-system';
import { auth as useAuthStore } from 'src/store/auth';

export default {
  name: 'SimpleLayout',

  components: { HrLayout, HrPageContainer },

  setup() {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark' || savedTheme === 'light') {
      document.documentElement.setAttribute('data-theme', savedTheme);
    }

    const authStore = useAuthStore();
    const { currentClient } = authStore;

    useMeta(() => {
      return {
        title: get(currentClient, 'alias') ?? get(currentClient, 'clientName') ?? 'Hi Rasmus',
      };
    });
  },

};
</script>
<style lang="scss">
.main-surface {
  background-color: var(--app-surface);
  color: var(--app-on-surface);
}
</style>
